// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { SortDirections } from '../../../models';
import { RespondentSurveyBaseService } from './respondent-survey-base.service';
import { ResponseBaseService } from '../survey/response-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class RespondentSurveyMockService extends RespondentSurveyBaseService {
  constructor(
    responseService: ResponseBaseService
  ) {
    super(responseService);
  }

  loadSummary(pageSize: number, pageNumber: number, filter: string, sortItem: string, sortDirection: SortDirections): void {
    throw new Error('Method not implemented.');
  }

  loadSurveyById(id: string): void {
    throw new Error('Method not implemented.');
  }
}
